import { cn } from "lib/utils";

const NewBadge = ({ className, children = "New", ...props }) => (
    <span
        className={cn(
            "inline-flex h-7 min-w-[68px] shrink-0 items-center justify-center rounded-full bg-gradient-to-r from-[#9B4DFF] to-[#7200FF] px-4 text-sm font-[450] uppercase leading-none tracking-[0.02em] text-white",
            className
        )}
        {...props}
    >
        {children}
    </span>
);

export default NewBadge;
